import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

interface Props {
  onLogin: (token: string, name: string, role: string) => void;
}

export default function Login({ onLogin }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API_URL}/auth/login`, { email, password });
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.token, res.data.name, res.data.role);
    } catch {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#020817', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Inter, -apple-system, sans-serif', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', background: 'radial-gradient(ellipse at 20% 20%, rgba(79,142,247,0.15) 0%, transparent 50%), radial-gradient(ellipse at 80% 80%, rgba(139,92,246,0.12) 0%, transparent 50%)' }} />
      <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: '420px', margin: '24px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(79,142,247,0.2)', borderRadius: '20px', padding: '48px 40px', backdropFilter: 'blur(20px)' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src="/reknew-logo.png" alt="ReKnew" style={{ height: "40px", marginBottom: "8px" }} />
          <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>Demos Portal</p>
        </div>
        <h2 style={{ color: '#f1f5f9', fontSize: '22px', fontWeight: '600', marginBottom: '24px', textAlign: 'center' }}>Sign in</h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#94a3b8', fontSize: '12px', fontWeight: '600', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '8px' }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={{ width: '100%', padding: '12px 16px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(79,142,247,0.2)', borderRadius: '10px', color: '#f1f5f9', fontSize: '15px', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', color: '#94a3b8', fontSize: '12px', fontWeight: '600', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '8px' }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ width: '100%', padding: '12px 16px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(79,142,247,0.2)', borderRadius: '10px', color: '#f1f5f9', fontSize: '15px', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          {error && <div style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '10px', padding: '12px 16px', color: '#fca5a5', fontSize: '14px', marginBottom: '16px' }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '13px', background: 'linear-gradient(135deg, #4f8ef7, #8b5cf6)', border: 'none', borderRadius: '10px', color: '#ffffff', fontSize: '15px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={{ color: '#475569', fontSize: '12px', textAlign: 'center', marginTop: '24px' }}>ReKnew Data & AI · Internal Portal</p>
      </div>
    </div>
  );
}
